<!--  -->
<template>
    <div class="bod">
    <Breadcrumb style="margin-top: 20px;margin-left: 163px;margin-bottom: 20px;color: rgb(110, 114, 117);">
        <BreadcrumbItem to="/">首页</BreadcrumbItem>
        <BreadcrumbItem to="/message">相关资讯</BreadcrumbItem>
        <BreadcrumbItem>详情</BreadcrumbItem>
    </Breadcrumb>
      <div class="flex">
        <div style="width: 1030px;" class="biaoti">
            【公益创投 暖席广州】朝九晚四“三步学会电商直播”主题培训
        </div>
      </div>
      <div class="flex">
      <div class="xgleft3"></div>
        <div class="xgleft4">就业创业</div>
        <div class="xgleft1">发布时间：&nbsp&nbsp2022.08.23</div>
      </div>
      <div class="flex">
        <div class="wenben1">
            为了充分发挥妇女能顶半边天的作用，结合灵活就业的大趋势，盘活乡村妇女劳动力， 2022年8月23日上午，第九届广州市社会组织公益创投活动“乡村振兴，社企共建——困境妇女直播技能提升帮扶计划”于黄埔区朝九晚四巾帼创客服务中心会议室举办“三步学会电商直播”主题培训活动，吸引了20多名困境妇女及乡村妇女学员参加本次培训。
        </div>
      </div>
      <div class="flex">
        <div class="page6tu1"></div>
      </div>
      <div class="flex">
        <div style="margin-bottom: 50px;" class="wenben2">        本次培训以提升困境妇女及乡村妇女的电商应用能力为目标、以直播带货为主题，邀请实战经验丰富的讲师，结合黄埔区的实际情况，围绕直播平台选择、短视频账号养成、短视频变现、直播话术、直播间建设成本分析等内容，通过边讲解边操作的模式，为学员们做了深入分享，使大家能快速吸收课堂知识并用于实践。</div>
      </div>
      <div class="flex">
        <div class="page6tu2"></div>
      </div>
      <div class="flex">
        <div style="margin-bottom: 0;height: 50px;" class="wenben3">                通过此次培训，不仅使学员们了解了电商直播的相关理论、直播工具，还通过交流探讨、即时反馈，提升了学员们的直播实战能力，助力妇女灵活创业及灵活就业，实现赚钱、顾家两不误。</div>
      </div>
      <div class="flex">
        <div class="page6tu3"></div>
      </div>
      <div class="flex">
        <div class="page6tu4"></div>
      </div>
      <div class="flex">
        <hr class="hr1"/>
      </div>
      <div style="margin-left: 163px;float: left;">
        <div class="next">上一篇</div>
        <div class="nextkuang">
          <div class="xgleft1">2022.09.06</div>
          <router-link to="/page5" class="text1">黄埔区妇女就业创业技能培训顺利开展</router-link>
          <div class="xgleft3"></div>
          <div class="xgleft4">就业创业</div>
          <router-link to="/page5" class="text2">为了提升黄埔区妇女就业创业能力，推动妇女融入社会，实现灵活就业创业，激发我区广大妇女群众积极投身经济社会高质量发展，9月6日上午，在区妇联主办和支持下黄埔区朝九晚四巾帼创客服务中心在萝岗街党群服务中心开展妇女就业创业技能培训，来自萝岗街、联和街、长岭街、云埔街的40多名妇女参加本次培训班......</router-link>
          <router-link to="/page5"><div class="text3">查看详情<img src="../../../assets/images/you.png"></div></router-link>
        </div>
      </div>
      <div style="margin-left: 75px;float: left;">
        <div class="next">下一篇</div>
        <div class="nextkuang">
          <div class="xgleft1">2022.05.16</div>
          <router-link to="/page7" class="text1">朝九晚四灵活用工进园区公益活动--走进莱迪创新科技园</router-link>
          <div class="xgleft3"></div>
          <div class="xgleft4">就业创业</div>
          <router-link to="/page7" class="text2">上周，朝九晚四巾帼创客中心为继续推动育儿妈妈灵活就业，充分发挥女性能顶“半边天”的重要作用，走进广州莱迪创新科技园区，与其负责人共同探讨园区内的朝九晚四灵活就业岗位开发主题......</router-link>
          <router-link to="/page7"><div class="text3">查看详情<img src="../../../assets/images/you.png"></div></router-link>
        </div>
      </div>
      <div class="clean"></div>
    </div>
  
  </template>
  
  <script>
  export default {
    data() {
      return {
  
      }
    },
    methods: {
  
    },
    created() {
  
    }
  }
  </script>
  
  <style lang="less" scoped>
  @import "./page.less";
  </style>
  